/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * damage
 */
export interface StructureDamageEntryDetails { 
    /**
     * primary Key
     */
    id?: number;
    /**
     * Structure damage id
     */
    structureDamageId?: number;
    /**
     * On this date the damage was noted first time
     */
    entryDatetime?: string;
    /**
     * severity
     */
    severity?: string;
    /**
     * description
     */
    description?: string;
    /**
     * location
     */
    location?: string;
    /**
     * remarks
     */
    remarks?: string;
}

